import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { DateInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { DateInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
import { Alert } from "@mui/material";
//#endregion
import * as Yup from "yup";
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

interface ScheduleChangeFormValues {
  startDate: Date;
}

interface ScheduleChangeFormProps {
  defaultDate?: Date;
  hasExistingSchedule?: boolean;
  minDate?: Date;
}

const ScheduleChangeForm: ForwardRefRenderFunction<FormHandles, ScheduleChangeFormProps> = (props, ref) => {
  const { defaultDate, hasExistingSchedule, minDate } = props;

  const initialValues: ScheduleChangeFormValues = {
    startDate: defaultDate ?? new Date(),
  };

  const validationSchema = Yup.object<ScheduleChangeFormValues>({
    startDate: Yup.date()
      .required(TranslationKeys.Validations.Required)
      .test("minDate", TranslationKeys.Validations.ToDateLessThanFromDate, function (value) {
        if (!minDate || !value) {
          return true;
        }
        return value >= minDate;
      }),
  });

  const handleSubmit = async (values: ScheduleChangeFormValues) => {
    return values;
  };

  const { wintFormProps, connect } = useWintForm<ScheduleChangeFormValues>({
    formRef: ref,
    defaultValues: initialValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit,
  });

  return (
    <WintForm {...wintFormProps}>
      <p className={cssExports.employeeScheduleChangeDescription}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.ScheduleChangesDescription)}
      </p>

      <VerticalFormField<DateInputProps>
        Component={DateInput}
        {...connect("startDate")}
        label={TranslationKeys.Settings.StartDate}
        minDate={minDate}
      />

      {hasExistingSchedule && (
        <Alert severity="info" sx={{ mt: 2, width: "100%" }}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.ReplaceExistingScheduleInfo)}
        </Alert>
      )}
    </WintForm>
  );
};

export default forwardRef(ScheduleChangeForm);
